import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: () => import('@/views/index/index.vue'),
      meta: {
        nav: 'home'
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Layout,
      redirect: '/login/main',
      children: [
        {
          path: 'main',
          name: 'login-main',
          component: () => import('@/views/login'),
          meta: {
            unauth: true
          }
        },

        {
          path: '/resetpwd/:admin?',
          name: 'resetpwd',
          component: () => import('@/views/resetpwd'),
          meta: {
            unauth: true
          },
          props({ params: { admin } }) {
            return {
              admin: admin == 'admin'
            }
          }
        }
      ]
    },

    {
      path: '/register',
      name: 'register',
      component: Layout,
      redirect: '/register/main',
      children: [
        {
          path: 'main',
          name: 'register-main',
          component: () => import('@/views/regist'),
          meta: {
            unauth: true
          }
        }
      ]
    },

    {
      path: '/:role',
      name: 'Layout',
      component: Layout,
      redirect: '/:role/home',
      children: [
        {
          path: 'home',
          name: 'Home',
          component: () => import('@/views/Home'),
          prop: true,
          meta: {
            nav: 'my'
          }
        },

        // 热点访谈
        {
          path: 'talk',
          name: 'talk',
          component: () => import('@/views/talk/index.vue'),
          props: true,
          meta: {
            nav: 'talk'
          }
        },

        // 我的问答
        {
          path: 'myask',
          name: 'myask',
          component: () => import('@/views/my/ask.vue'),
          props: true,
          meta: {
            nav: 'my'
          }
        },
        {
          path: 'certify',
          name: 'certify',
          component: () => import('@/views/my/certify.vue'),
          props: true,
          meta: {
            nav: 'my'
          }
        },

        {
          path: 'recommendCourse',
          name: 'recommendCourse',
          component: () => import('@/views/my/recommendCourse.vue'),
          props: true,
          meta: {
            nav: 'my'
          }
        },

        // 用户：我的作业
        {
          path: 'myhomework',
          name: 'myhomework',
          component: () => import('@/views/my/homework.vue'),
          props: true,
          meta: {
            nav: 'my'
          }
        },


        // 管理员：管理考试
        {
          path: 'adminExam',
          name: 'adminExam',
          component: () => import('@/views/admin/adminExam.vue'),
          props: true,
          meta: {
            nav: 'adminExam'
          }
        },

        // 管理员：管理作业
        {
          path: 'homework',
          name: 'homework',
          component: () => import('@/views/admin/homework.vue'),
          props: true,
          meta: {
            nav: 'homework'
          }
        },
        // 管理员：岗位部门设置
        {
          path: 'positionSetting',
          name: 'positionSetting',
          component: () => import('@/views/admin/positionSetting.vue'),
          props: true,
          meta: {
            nav: 'positionSetting'
          }
        },

        // 课程
        // {
        //   path: 'manage',
        //   name: 'manage',
        //   component: () => import('@/views/Manage'),
        //   prop: true,
        //   meta: {
        //     // useSearch: true,
        //     nav: 'course'
        //   }
        // },

        {
          path: 'manage',
          name: 'manage',
          component: () => import('@/views/Manage'),
          prop: true,
          meta: {
            useSearch: true,
            nav: 'course'
          }
        },

        {
          path: 'lives',
          name: 'lives',
          component: () => import('@/views/lives'),
          prop: true,
          meta: {
            useSearch: true,
            nav: 'lives'
          }
        },

        {
          path: 'addCourse',
          name: 'addCourse',
          component: () => import('@/views/courseManage/addCourse.vue'),
          props: true,
          meta: {
            nav: 'course'
          }
        },

        {
          path: 'updateCourse',
          name: 'updateCourse',
          component: () => import('@/views/courseManage/updateCourse.vue'),
          props: true,
          meta: {
            nav: 'course'
          }
        },

        {
          path: 'courseClass',
          name: 'courseClass',
          component: () => import('@/views/courseManage/courseClass.vue'),
          props: true,
          meta: {
            nav: 'course'
          }
        },

        {
          path: 'teacherManage',
          name: 'teacherManage',
          component: () => import('@/views/courseManage/teacherManage.vue'),
          props: true,
          meta: {
            nav: 'course'
          }
        },

        // 职场充电
        {
          path: 'article',
          name: 'article',
          component: () => import('@/views/article/index.vue'),
          props: true,
          meta: {
            nav: 'article'
          }
        },

        // 职场充电详情
        {
          path: 'article/:id',
          name: 'articleDetail',
          component: () => import('@/views/article/detail.vue'),
          props: true,
          meta: {
            nav: 'article'
          }
        },

        {
          path: 'setting',
          name: 'OrderSetting',
          component: () => import('@/views/Order'),
          prop: true,
          meta: {
            nav: 'setting'
          }
        },
        {
          path: 'recharge',
          name: 'OrderRecharge',
          component: () => import('@/views/recharge'),
          prop: true,
          meta: {
            nav: 'recharge'
          }
        },

        {
          path: 'saff',
          name: 'saff',
          component: () => import('@/views/Saff'),
          prop: true,
          meta: {
            nav: 'saff'
          }
        },
        // 近七天完成课程详情
        {
          path: 'endLessonNum',
          name: 'endLessonNum',
          component: () => import('@/views/endLessonNum'),
          prop: true,
          meta: {
            nav: 'saff'
          }
        },

        {
          path: 'addRequiredCourse',
          name: 'addRequiredCourse',
          component: () => import('@/views/staffManage/addRequiredCourse.vue'),
          prop: true,
          meta: {
            nav: 'saff'
          }
        },

        {
          path: 'study/:id/learn',
          name: 'study',
          component: () => import('@/views/Study'),
          prop: true,
          meta: {
            nav: 'course'
          }
        },

        {
          path: 'study/live/:id',
          name: 'live',
          component: () => import('@/views/live'),
          prop: true,
          meta: {
            nav: 'live'
          }
        },

        // {
        //   path: 'numberStudy/:id/learn',
        //   name: 'numberStudy',
        //   component: () => import('@/views/numberStudy'),
        //   prop: true,
        //   meta: {
        //     nav: 'course'
        //   }
        // },
        {
          path: 'numberStudy/:id/learn',
          name: 'numberStudy',
          component: () => import('@/views/shuziStudy'),
          prop: true,
          meta: {
            nav: 'course'
          }
        },

        {
          path: 'study/:id/exam',
          name: 'exam',
          component: () => import('@/views/Exam'),
          prop: true,
          meta: {
            nav: 'course'
          }
        },

        {
          path: 'study/:id/task',
          name: 'task',
          component: () => import('@/views/Task'),
          prop: true,
          meta: {
            nav: 'course'
          }
        },

        {
          path: 'ceping',
          name: 'ceping',
          component: () => import('@/views/ceping/index.vue'),
          props: true,
          meta: {
            nav: 'course'
          }
        },

        {
          path: 'ask',
          name: 'ask',
          component: () => import('@/views/ask/index.vue'),
          props: true,
          meta: {
            nav: 'ask'
          }
        },

        {
          path: 'ask/new',
          name: 'ask-new',
          component: () => import('@/views/ask/new.vue'),
          props: true,
          meta: {
            nav: 'ask'
          }
        },

        {
          path: 'ask/:id',
          name: 'ask-detail',
          component: () => import('@/views/ask/detail.vue'),
          props: true,
          meta: {
            nav: 'ask'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js